import React from 'react';

export interface IPaginationTotalProps {
  from: number;
  to: number;
  size: number;
}

export const PaginationTotal: React.FC<IPaginationTotalProps> = ({ from, to, size }) => (
  <div>
    Showing {from} to {to} of {size} results.
  </div>
);
